module.exports = "/images/arrow-left-s-line.svg?390cfe6c039f3b5f9cde16314c0c793f";